const rotterdamTimeFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Amsterdam',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
  timeZoneName: 'short',
})

export const formatRotterdamClockTime = (date) =>
  rotterdamTimeFormatter.format(date)
